module.exports = __webpack_public_path__ + "img/2.06955b06.png";